<template>
    <div class="conversation-chip" :class="{ selected }">
        <p class="conversation-title">{{ truncatedTitle }}</p>
        <span v-if="!selected" class="messages-number">({{ messagesNumber }})</span>

    </div>
</template>

<script>
export default {
    props: {
        conversationId: {
            type: String,
            required: true
        },
        conversationTitle: {
            type: String,
            required: true
        },
        messagesNumber: {
            type: Number,
            required: true
        },
        selected: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        truncatedTitle() {
            let title = this.conversationTitle;
            let maxLength = 140;
            let firstWordMaxLength = 35;

            // Split the title into words
            let words = title.split(/\s+/);

            // Process the first word
            if (words[0].length > firstWordMaxLength) {
                words[0] = words[0].slice(0, 32) + '...';
            }

            // Reconstruct the title
            title = words.join(' ');

            // Truncate the title if it exceeds maxLength
            if (title.length > maxLength) {
                title = title.slice(0, maxLength) + '...';
            }

            return title;
        }
    }
}
</script>

<style scoped>
.conversation-chip {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding: 12px 24px;
    background-color: transparent;
    border-radius: 0 6px 6px 0;
    cursor: pointer;
    margin-bottom: 6px;
    box-sizing: border-box;
    max-width: 100%;
    transition: all .2s ease-in-out;
    color: #333;
}

.conversation-chip.selected {
    background-color: #fff;
    color: #a1344e;
    margin-bottom: 12px;
    align-self: flex-end;
    border-radius: 6px 0 0 6px;
    font-size: 14pt;
    border-right: none;
    position: sticky;
    top: 0;
    flex-direction: column;
}

.conversation-chip.selected .conversation_id-p {
    color: #a1344e;
}



.conversation-chip:hover {
    background-color: #fff;
    color: #1f1c1c;
}


.conversation-title {
    line-height: 1.1;
}

.messages-number {
    margin-left: 4px;
    color: #888;
}

.selected .messages-number {
    margin-left: 4px;
    color: #eee;
}

.conversation_id-p {
    margin-top: 6px;
    font-size: 10pt;
    color: #eee;
}

@media screen and (max-width: 1100px) {
    .conversation-title {
        font-size: 11pt;
    }
}
</style>